import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Gating por plan de COREX Multifamiliar (Fase A) + override POSITIVO de
// licencia (F3). Fuente de verdad del plan: GET /vm/plan/features. Fuente única
// de la licencia: GET /software/mi-licencia/vivienda-multifamiliar (F2).
export const PLAN_FEATURES_DEFAULT = {
  multinivel: false,
  nivel_especifico: false,
  bd_estructural: false,
  export_doc: false,
  export_excel: false,
  export_pdf: false,
  export_planos: false,
};

export function usePlanFeatures() {
  const [plan, setPlan] = useState("basico");
  const [features, setFeatures] = useState(PLAN_FEATURES_DEFAULT);
  const [licencia, setLicencia] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    Promise.all([
      api.get("/vm/plan/features"),
      api.get("/software/mi-licencia/vivienda-multifamiliar").catch(() => ({ data: null })),
    ])
      .then(([f, l]) => {
        if (!alive) return;
        const planData = f.data || {};
        const baseFeatures = { ...PLAN_FEATURES_DEFAULT, ...(planData.features || {}) };
        const lic = l.data || null;
        const licVigente = lic?.estado === "vigente";
        // Override POSITIVO: la licencia vigente desbloquea TODO lo licenciable.
        // Jerarquía: admin (ya viene true del backend) → licencia → plan. Nunca restringe.
        const eff = licVigente
          ? Object.fromEntries(Object.keys(baseFeatures).map((k) => [k, true]))
          : baseFeatures;
        setPlan(planData.plan || "basico");
        setFeatures(eff);
        setLicencia(lic);
      })
      .catch(() => {})
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return { plan, features, licencia, loading, isBasico: plan === "basico" };
}
